export const ADMIN = 'ADMIN';
export const SUPER = 'SUPER';
export const EDIT = 'EDIT';
export const VIEW = 'VIEW';
